import { LeftOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Row>
      <Col span={24}>
        <Button
          type='link'
          ghost
          style={{
            padding: 0,
            color: '#DBDBDB',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'cemter',
          }}
          onClick={() => navigate(-1)}
          key='back'
        >
          <LeftOutlined style={{ fontSize: '24px' }} />
          Voltar
        </Button>
      </Col>
    </Row>
  );
};
